import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';

// Layouts
import MainLayout from './components/layout/MainLayout';

// Componentes públicos
import PublicHome from './components/public/PublicHome';
import ProductCatalogNew from './components/public/ProductCatalogNew';
import AboutPage from './components/pages/AboutPage';
import ContactPage from './components/pages/ContactPage';
import PromotionsPage from './components/pages/PromotionsPage';
import ShippingPage from './components/pages/ShippingPage';
import CartPage from './components/pages/CartPage';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';

// Checkout components
import Checkout from './components/checkout/Checkout';
import CheckoutSuccess from './components/checkout/CheckoutSuccess';
import MercadoPagoResult from './pages/checkout/MercadoPagoResult';

import CustomerDashboard from './components/customer/CustomerDashboard';

// Componentes privados (dashboard de administrador)
import Layout from './components/admin/dashboard/Layout';
import Dashboard from './components/admin/dashboard/DashboardSimple';
import DashboardPedidosOnline from './components/admin/dashboard/DashboardPedidosOnline';
import DashboardPagos from './components/admin/dashboard/DashboardPagos';
import DashboardProductos from './components/admin/dashboard/DashboardProductos';
import DashboardCategorias from './components/admin/dashboard/DashboardCategorias';
import DashboardInventario from './components/admin/dashboard/DashboardInventario';
import DashboardVentas from './components/admin/dashboard/DashboardVentas';
import DashboardUsuarios from './components/admin/dashboard/DashboardUsuarios';
import AdminProtectedRoute from './components/auth/AdminProtectedRoute';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DebugUserRole from './components/admin/DebugUserRole';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2E7D32',
    },
    secondary: {
      main: '#FFC107',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <AuthProvider>
          <CartProvider>
            <Router>
            <Routes>
            {/* Rutas públicas sin MainLayout - usan PublicNavigation */}
            <Route path="/" element={<PublicHome />} />
            <Route path="/productos" element={<ProductCatalogNew />} />
            
            {/* Rutas de autenticación */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Rutas de Checkout */}
            <Route path="/checkout" element={<MainLayout><Checkout /></MainLayout>} />
            <Route path="/checkout/success/:pedidoId" element={<MainLayout><CheckoutSuccess /></MainLayout>} />
            <Route path="/checkout/success" element={<MainLayout><MercadoPagoResult /></MainLayout>} />
            <Route path="/checkout/failure" element={<MainLayout><MercadoPagoResult /></MainLayout>} />
            <Route path="/checkout/pending" element={<MainLayout><MercadoPagoResult /></MainLayout>} />
    
            {/* Rutas de Mi Cuenta - Protegidas */}
            <Route path="/mi-cuenta" element={
              <ProtectedRoute>
                <MainLayout><CustomerDashboard /></MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/mi-cuenta/perfil" element={
              <ProtectedRoute>
                <MainLayout><CustomerDashboard /></MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/mi-cuenta/pedidos" element={
              <ProtectedRoute>
                <MainLayout><CustomerDashboard /></MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/mi-cuenta/direcciones" element={
              <ProtectedRoute>
                <MainLayout><CustomerDashboard /></MainLayout>
              </ProtectedRoute>
            } />
            <Route path="/mi-cuenta/metodos-pago" element={
              <ProtectedRoute>
                <MainLayout><CustomerDashboard /></MainLayout>
              </ProtectedRoute>
            } />
          
            
            {/* Rutas adicionales */}
            <Route path="/acerca" element={
              <MainLayout>
                <AboutPage />
              </MainLayout>
            } />
            <Route path="/contacto" element={
              <MainLayout>
                <ContactPage />
              </MainLayout>
            } />
            <Route path="/promociones" element={
              <MainLayout>
                <PromotionsPage />
              </MainLayout>
            } />
            <Route path="/envios" element={
              <MainLayout>
                <ShippingPage />
              </MainLayout>
            } />
            <Route path="/carrito" element={
              <MainLayout>
                <CartPage />
              </MainLayout>
            } />
            
            {/* Rutas de administración - Solo para administradores */}
            <Route path="/debug-role" element={
              <MainLayout>
                <DebugUserRole />
              </MainLayout>
            } />
            {/* Rutas protegidas (Dashboard) - Solo para administradores */}
            <Route path="/dashboard/*" element={
              <AdminProtectedRoute>
                <Layout>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="pedidos-online" element={<DashboardPedidosOnline />} />
                    <Route path="pagos" element={<DashboardPagos />} />
                    <Route path="productos" element={<DashboardProductos />} />
                    <Route path="categorias" element={<DashboardCategorias />} />
                    <Route path="usuarios" element={<DashboardUsuarios />} />
                    <Route path="inventario" element={<DashboardInventario />} />
                    <Route path="ventas" element={<DashboardVentas />} />
                  </Routes>
                </Layout>
              </AdminProtectedRoute>
            } />
            
            {/* Redirigir rutas no encontradas */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Router>
          </CartProvider>
        </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
